export default __webpack_public_path__ + "static/media/mario1.5280608e.jpeg";